const CurrenciesActionTypes = {
    START_GET_CURRENCIES_FROM_ASSETS: 'START_GET_CURRENCIES_FROM_ASSETS',
    SUCCESS_GET_CURRENCIES_FROM_ASSETS: 'SUCCESS_GET_CURRENCIES_FROM_ASSETS',
    FAILURE_GET_CURRENCIES_FROM_ASSETS: 'FAILURE_GET_CURRENCIES_FROM_ASSETS',
    FINISH_GET_CURRENCIES_FROM_ASSETS: 'FINISH_GET_CURRENCIES_FROM_ASSETS',
    START_GET_CURRENCIES: 'START_GET_CURRENCIES',
    SUCCESS_GET_CURRENCIES: 'SUCCESS_GET_CURRENCIES',
    FAILURE_GET_CURRENCIES: 'FAILURE_GET_CURRENCIES',
    FINISH_GET_CURRENCIES: 'FINISH_GET_CURRENCIES',
}

export default CurrenciesActionTypes
